import React, { createContext } from "react";
import PropTypes from "prop-types";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { isNil } from "lodash";
import { Case } from "interfaces/case";

interface CaseContextType {
  loading: boolean;
  error: boolean;
  caseData: Case | undefined;
  refetchCase(): Promise<void>;
}

export const CaseContext = createContext<CaseContextType>({
  loading: true,
  error: false,
  caseData: undefined,
  refetchCase: async () => {}
});
CaseContext.displayName = "CaseContext";

export interface CaseProviderProps {
  caseId: number;
}

export const CaseProvider = ({
  children,
  caseId
}: React.PropsWithChildren<CaseProviderProps>): JSX.Element => {
  const {
    loading,
    error,
    response: caseData,
    refetch: refetchCase
  } = useFetchGetV2(`cases/${caseId}`, isNil(caseId));

  return (
    <CaseContext.Provider value={{ loading, error, caseData, refetchCase }}>
      {children}
    </CaseContext.Provider>
  );
};

CaseProvider.propTypes = {
  children: PropTypes.node,
  caseId: PropTypes.number
};
